export default "__VITE_ASSET__DCkFoL9K__"